import { useState, useEffect } from 'react';

function useCountries() {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const getCountries = async () => {
      const response = await fetch('/api/bread/countries/search');
      const newCountries = await response.json();
      if (response.status === 200) {
        setCountries(newCountries.results);
      }
    };
    getCountries();
  }, []);

  return { countries };
}

export default useCountries;
